import _ from 'lodash';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { NAME_ACTION, NAME_MODE } from './reducer/settlePaymentNameReducer';
import { FormControl, FormHelperText, MenuItem, Select, TextField } from '@mui/material';

const SettlePaymentName = ({ profile, booking, isMultiMode, nameState, dispatchName, error, errorMessage, clearError }) => {
	const { t } = useTranslation();
	const inputRef = useRef(null);

	const invoiceNames = _.get(profile, 'company.invoice_ids', []).map((i) => ({ id: i.id, name: i.name }));

	let selectValue = '';

	switch (nameState.mode) {
		case NAME_MODE.OTHER:
			selectValue = NAME_MODE.OTHER;
			break;

		case NAME_MODE.INVOICE: {
			const match = invoiceNames.find(i => i.id === nameState.invoiceId);
			selectValue = match ? match.name : '';
			break;
		}

		case NAME_MODE.NAME:
			selectValue = nameState.name || '';
			break;

		default:
			selectValue = '';
	}

	useEffect(() => {
		if (nameState.mode === NAME_MODE.OTHER && inputRef.current) inputRef.current.focus();
	}, [nameState.mode]);

	const handleSelectChange = (e) => {
		const value = e.target.value;
		clearError();

		if (value === NAME_MODE.OTHER) {
			dispatchName({ type: NAME_ACTION.SELECT_OTHER, prefill: nameState.otherName || '' });
			return;
		}

		const invoice = invoiceNames.find((inv) => inv.name === value);
		if (invoice) {
			dispatchName({ type: NAME_ACTION.SELECT_INVOICE_ID, invoiceId: invoice.id });
		} else {
			dispatchName({ type: NAME_ACTION.SELECT_NAME, name: value });
		}
	};

	const handleOtherNameChange = (e) => {
		const reg = /^[a-zA-Z\s]*$/;
		if (reg.test(e.target.value)) {
			dispatchName({ type: NAME_ACTION.SET_OTHER_NAME, otherName: e.target.value });
			clearError();
		}
	};

	const firstTraveler = !isMultiMode ? _.get(booking, 'travelers[0]', null) : null;
	const firstTravelerName = firstTraveler ? `${firstTraveler.first_name} ${firstTraveler.last_name}` : '';

	const isOther = nameState.mode === NAME_MODE.OTHER;

	return (
		<FormControl fullWidth variant="outlined" className="name-on-invoice" error={error}>
			<FormHelperText id="outlined-helper-text">{t('Bookings.SettlePayment.NameOnInvoice')}</FormHelperText>

			<Select value={selectValue} onChange={handleSelectChange} displayEmpty error={error && !isOther}>
				<MenuItem value="" disabled>
					{t('Bookings.SettlePayment.SelectAName')}
				</MenuItem>
				{invoiceNames.map(({ id, name }) => (
					<MenuItem key={id} value={name}>
						{name}
					</MenuItem>
				))}
				{firstTravelerName && <MenuItem value={firstTravelerName}>{firstTravelerName}</MenuItem>}
				<MenuItem value={NAME_MODE.OTHER}>{t('Bookings.SettlePayment.Other')}</MenuItem>
			</Select>

			{error && !selectValue && <FormHelperText error>{errorMessage}</FormHelperText>}

			{isOther && (
				<TextField
					className="name-on-invoice-other"
					fullWidth
					placeholder={t('Bookings.SettlePayment.EnterAName')}
					value={nameState.name}
					onChange={handleOtherNameChange}
					inputRef={inputRef}
					error={error && !nameState.name}
					helperText={error && !nameState.name ? t('Bookings.SettlePayment.PleaseEnterName') : ''}
				/>
			)}
		</FormControl>
	);
};

export default SettlePaymentName;
